import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminPage.css';

function AdminView() {
  const [competitions, setCompetitions] = useState([]);
  const [newCompName, setNewCompName] = useState('');
  const [startTime, setStartTime] = useState('');

  const API = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');

  let authorised = localStorage.getItem('adminstatus');
  if(authorised !== 'admingranted') {
    navigate('/')
  }

  // Fetch competitions with participant counts
  const fetchCompetitionsWithCounts = async () => {
    try {
      const res = await fetch(`${API}/competitions`);
      const comps = await res.json();

      const compsWithCounts = await Promise.all(
        comps.map(async (comp) => {
          const fencersRes = await fetch(`${API}/competitions/${comp.id}/fencers`);
          const fencers = await fencersRes.json();
          return { ...comp, fencer_count: fencers.length };
        })
      );

      setCompetitions(compsWithCounts);
    } catch (err) {
      console.error('Error fetching competitions with counts:', err);
    }
  };

  useEffect(() => {
    fetchCompetitionsWithCounts();
  }, []);

  // Create a new competition
  const createCompetition = async () => {
    if (!newCompName.trim()) {
      setErrorMessage('The competition needs a name');
      setTimeout(() => setErrorMessage(''), 3000);
      return;
    }

    try {
      const res = await fetch(`${API}/competitions`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: newCompName, start_time: startTime }),
      });

      if (res.ok) {
        setNewCompName('');
        setStartTime('');
        fetchCompetitionsWithCounts();
      }
    } catch (err) {
      console.error('Error creating competition:', err);
    }
  };

  // Toggle competition active status
  const toggleActive = async (id, currentStatus) => {
    try {
      const res = await fetch(`${API}/competitions/${id}/active`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ active: !currentStatus }),
      });

      if (res.ok) {
        fetchCompetitionsWithCounts();
      }
    } catch (err) {
      console.error('Error toggling status:', err);
    }
  };

  return (
    <div className="admin-page">
      <button className="link-button" onClick={() => navigate(`/`)}>← Back</button>
      <h2>Admin Panel</h2>

      <div style={{ marginBottom: '20px' }}>
        <input
          type="text"
          placeholder="Competition name"
          value={newCompName}
          onChange={(e) => setNewCompName(e.target.value)}
        />
        <input
          type="time"
          className="short-input"
          placeholder="Start time (optional)"
          value={startTime}
          onChange={(e) => setStartTime(e.target.value)}
        />
        <button onClick={createCompetition} className="accept-button">Create Competition</button>
      </div>

      <ul>
        {competitions.map((comp) => (
          <li
            key={comp.id}
            className={comp.active ? 'competition-active' : 'competition-inactive'}
          >
            <div className="comp-info">
              <span className="comp-name">{comp.name}</span>
              <span className="comp-status">
                {comp.active ? '🟢 Active' : '🔴 Inactive'}
                {comp.start_time && (<span>, 🕒 {comp.start_time}</span>)}
                <span className="comp-participants">
                    Participants: {comp.fencer_count || 0}
                </span>
              </span>
            </div>

            {!comp.active && (
              <button
                onClick={() => {
                  if (
                    window.confirm(
                      `Are you sure you want to delete competition "${comp.name}"? This action cannot be undone.`
                    )
                  ) {
                    fetch(`${API}/competitions/${comp.id}`, {
                      method: 'DELETE',
                    }).then(() => {
                      setCompetitions((prev) =>
                        prev.filter((c) => c.id !== comp.id)
                      );
                    });
                  }
                }}
                className="danger-button"
                style={{ marginLeft: '10px' }}
              >
                Delete
              </button>
            )}

            <div className="comp-actions">
              <button onClick={() => toggleActive(comp.id, comp.active)}>
                {comp.active ? 'Toggle Inactive' : 'Toggle Active'}
              </button>
              <button onClick={() => navigate(`/admin/competition/${comp.id}`)}>
                Manage
              </button>
            </div>
          </li>
        ))}
      </ul>

      <div className={errorMessage ? 'error-message' : ''}>
        <p>{errorMessage}</p>
      </div>
    </div>
  );
}

export default AdminView;
